import React from 'react'
import { useTranslation } from 'react-i18next'

import BaseElement from './BaseElement';
import { noop } from 'utils';

export function renderTitleElement(params) {
  return (props) => {
    if (props.element.type === 'title') { 
      return (
          <TitleElement {...props} {...params} />
      );
    }
  
    return undefined;
  }
}



export const TitlePlugin = (params = {}) => ({
  renderElement: renderTitleElement(params),
});

export default function TitleElement({ attributes, element, children, ...props }) {
  const { t } = useTranslation();

  return (
    <BaseElement className="title-element" textAlign="center" element={element} type="title" {...props} {...attributes} contentStyle={{
      fontWeight: 'bold'
    }}>
      {({ isEmpty }) => (
        <React.Fragment>
          { isEmpty && <BaseElement.Placeholder text={t('editor.items.title')} style={{left: `calc(50% - ${t('editor.items.title').length*5}px)`}} /> }
          {/* <span {...attributes}> */}
                  {children}
          {/* </span> */}
        </React.Fragment>
      )}
    </BaseElement>
  )
}